module.exports = __webpack_public_path__ + "img/icn_deadline.2a716f8d.svg";